// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"c67f25d2","330":"55aa9350","385":"7d725818","490":"1c473614","620":"e247dee9"}[chunkId] + ".chunk.css";
};